import { useMemo } from "react";

import { useSelectedWorkspaceContext } from "common/context/SelectedWorkspaceContext";

export default function useCampaignValidation(owners: string[]) {
  const { accounts, licenses } = useSelectedWorkspaceContext();

  return useMemo(() => {
    const availableSeatsCount = licenses.filter(
      ({ account_id }) => !account_id,
    ).length;

    const workerAccountsWithoutSeat = accounts.filter(
      // Only include accounts that are campaign owners but don't have licenses
      ({ id, license, type }) =>
        owners.includes(id) && type === "user" && !license,
    );

    const hasInsufficientLicenses =
      workerAccountsWithoutSeat.length > availableSeatsCount;

    const missingSeatsCount = hasInsufficientLicenses
      ? workerAccountsWithoutSeat.length - availableSeatsCount
      : 0;

    return {
      availableSeatsCount,
      workerAccountsWithoutSeat,
      hasInsufficientLicenses,
      missingSeatsCount,
    };
  }, [accounts, licenses, owners]);
}
